import type { Point2d } from "."
import { matchAllPairs } from "../matching"

export const offsetPointPairs = (
  points1: Point2d[],
  points2: Point2d[],
): { offset: Point2d; pair: { p1: Point2d; p2: Point2d } }[] =>
  matchAllPairs(
    (p1, p2) => ({
      offset: { x: p1.x - p2.x, y: p1.y - p2.y },
      pair: { p1, p2 },
    }),
    points1,
    points2,
  )
